<template>
    <div class="mesomerie">
        <p>
            Moleküle mit Grenzstrukturformeln.<br />
            z.B. Benzol
        </p>
    </div>
</template>

<script>
export default {
    name: 'mesomerie',
};
</script>
